import React, { useState } from 'react'
import { useRef } from 'react'
import arrowUpright from '../../Assets/svgs/arrowUpright.svg'
import arrow from '../../Assets/arrow.png'
import { alphanumericDate } from '../../constents/functions';
import useConsent from '../../Hooks/Interview/useConsent';
import videoRecorderIcon from '../../Assets/svgs/Interview/videoRecorderIcon.svg';
import startRecordPreviewImg from '../../Assets/svgs/Interview/startRecoredPreview.svg';
import stopRecordPreviewIcon from '../../Assets/svgs/Interview/stopRecordPreviewIcon.svg';
import previewRecordedSuccessfully from '../../Assets/svgs/Interview/previewRecordedSuccessfully.svg';
import { Loader } from '../../constents/components'
import { useSelector } from 'react-redux';
import Interview from './Interview';
import MockConsent from './MockConsent';


const ConsentSection = ({ consentAccepter }) => {

    const AllowCameraButton = ({ getCameraAndStartPreview }) => (
        <div onClick={getCameraAndStartPreview} className=' cursor-pointer flex gap-2 bg-white rounded-full px-4 py-2'>
            <img src={videoRecorderIcon} alt="videoRecorderIcon" />
            <span className=' text-lg font-semibold'>Allow camera</span>
        </div>
    );
    const PreviewRecordStartButton = ({ startRecordingPreview }) => (
        <div onClick={startRecordingPreview} className=' cursor-pointer flex gap-2 bg-[#FF5D0E] rounded-full px-4 py-2'>
            <img src={startRecordPreviewImg} alt="startRecordPreviewImg" />
            <span className=' text-lg  text-white font-semibold'>Start Recording</span>
        </div>
    );
    const PreviewRecordingStopButton = ({ stopRecordingPreview }) => (
        <div onClick={stopRecordingPreview} className=' cursor-pointer flex gap-2 bg-[#FF5D0E] rounded-full px-4 py-2'>
            <img src={stopRecordPreviewIcon} alt="stopRecordPreviewIcon" />
            <span className=' text-lg  text-white font-semibold'>Stop Recording</span>
        </div>
    );
    const RecordingSuccessStatus = () => (<div className=' cursor-pointer flex flex-col items-center rounded-full px-4 py-2'>
        <img className='w-8' src={previewRecordedSuccessfully} alt="stopRecordPreviewIcon" />
        <h1 className=' text-xl  text-[#34A853] font-semibold'>Video Recorded!</h1>
        <span className=' text-lg  text-white font-semibold'>You can now start your interview</span>
    </div>);
    const videoElement = useRef();
    const queryParams = new URLSearchParams(window?.location.search);
    const interviewId = queryParams.get('q');

    const {
        StatesOfVideo,
        videoStatus,
        loading,
        startRecordingPreview,
        stopRecordingPreview,
        startInterview,
        getCameraAndStartPreview,
    } = useConsent(videoElement, interviewId);

    const firstName = useSelector(store => store.user.FirstName);

    const UserName = queryParams.get('name') ?? firstName;
    const JobTitle = queryParams.get('job') ?? '';
    const CompanyName = queryParams.get('company') ?? '';
    const NoOfQuestions = queryParams.get('questions') ?? 10;
    const DateOfToday = alphanumericDate(Date.now());
    const EstimatedTimeToCompleteInterview = 18;

    const Heading = 'Before we proceed, we will need your declaration';
    const Discription = 'Switch on your camera and recite the following excerpt:';
    const TextToRead = `"Hello, my name is ${UserName}. Today is ${DateOfToday}, and I am about to begin my online interview for ${JobTitle} at ${CompanyName}. I confirm that I am completing this interview by myself without any external help. I understand that the interview will be monitored and recorded to ensure fairness. I am ready to begin."`;

    const NumberOfQuestionText = 'Total Question: ';
    const TimeRequiredText = 'Estimated Time Required : ';
    const TimeRequiredValue = `${EstimatedTimeToCompleteInterview} mins`;


    const handleStartInterview = async () => {
        await startInterview();
        consentAccepter();
    }

    return loading ? <Loader /> :
        <div className=''>
            <div className=' w-[90vw] lg:w-[80vw] bg-white px-4 py-4 border-[1px] border-gray-200 rounded-2xl'>
                <div className=' flex items-start'>
                    <h1 className=' flex-1 text-3xl font-semibold'>Self Declaration</h1>
                    <div className=' flex-1 flex justify-end'>

                    </div>
                </div>

                <div className=' flex justify-between mt-2'>
                    <p className=' text-gray-700'>{NumberOfQuestionText}<span className=' text-black font-semibold'>{NoOfQuestions}</span></p>
                    <p className=' text-gray-700'>{TimeRequiredText}<span className=' text-black font-semibold'>{TimeRequiredValue}</span></p>
                </div>

                <div className=' flex flex-col-reverse lg:flex-row gap-12 mt-4 bg-[#F9F9F9] p-4 rounded-2xl'>
                    <div className='flex-1 '>
                        <h4 className=' text-2xl font-bold'>{Heading}</h4>
                        <p className="text-gray-500 mt-1">{Discription}</p>
                        <p className="text-gray-600 mt-4">{TextToRead}</p>
                    </div>
                    <div className=' flex-1 relative rounded-2xl overflow-hidden'>
                        <div className=' z-10 absolute top-0 left-0 right-0 bottom-0 flex items-end pb-8 justify-center'>
                            {videoStatus === undefined && <AllowCameraButton getCameraAndStartPreview={getCameraAndStartPreview} />}
                            {videoStatus === StatesOfVideo.ready && <PreviewRecordStartButton startRecordingPreview={startRecordingPreview} />}
                            {videoStatus === StatesOfVideo.recording && <PreviewRecordingStopButton stopRecordingPreview={stopRecordingPreview} />}
                            {videoStatus === StatesOfVideo.recorded && <RecordingSuccessStatus />}
                        </div>
                        {(videoStatus === undefined || videoStatus === StatesOfVideo.recorded) && (<div className=' rounded-2xl overflow-hidden  w-full bg-black aspect-video'></div>)}
                        {(<video ref={videoElement} muted autoPlay playsInline className={`rounded-2xl overflow-hidden  ${(videoStatus === undefined || videoStatus === StatesOfVideo.recorded) ? 'w-0' : 'w-full'}`} />)}

                    </div>
                </div>


                <div className="flex space-x-4 mt-10">
                    {/* <button className="px-8 py-3 border border-gray-300 rounded-full hover:bg-gray-50">
                        Skip
                    </button> */}
                    <button className={`px-8 py-3 text-white rounded-full  flex items-center ${videoStatus === StatesOfVideo.recorded ? 'bg-black cursor-pointer' : ' bg-gray-300 cursor-not-allowed'}`} onClick={() => videoStatus === StatesOfVideo.recorded && handleStartInterview()}>
                        Start Interview
                        <img src={arrow} alt='external-link'
                            className=' w-3 h-3 ml-2'
                        />
                    </button>
                </div>
            </div>

            {/* {videoStatus === StatesOfVideo.recorded && <video autoPlay src={videoChunks.current.preivewUrl} />} */}
        </div>
}

const Instruction = ({ onAccepted }) => {

    const instructions = [
    "Ensure a stable internet connection and a quiet environment",
    "Make sure your devices microphone and camera are functioning.",
    "Keep your camera at eye level.",
    "Please ensure to attend the interview in a quiet environment with minimal distractions.",
    "For every question, you’ll get a maximum of 3 minutes to respond. Try to structure your answer within this time frame.",
    "If you finish answering within 3 min, Click on the “Next” button to proceed to the next question.",
    "You can click Submit button to end the interview at anytime, though skipping questions and incomplete interview will affect your feedback report. You will not be able to re-take the interview either.",
    "Please note: Mock interviews are not proctored, however AI Job Interviews on Zepcruit which is initiated by recruiters are proctored for fair evaluation of all applicants"
   ];

    return (
        <div className=''>
            <div className='w-[80vw] bg-white px-4 py-4 border-[1px] border-gray-200 rounded-2xl'>
                <div className=' flex items-start'>
                    <h1 className=' flex-1 text-3xl font-semibold'>Getting Started with Interview</h1>
                </div>

                <div className=' bg-[#F9F9F9] px-8 py-6 rounded-2xl mt-4'>
                    <h4 className=' text-xl font-bold'>Please read following instructions carefully:</h4>
                    <div className="space-y-4 mt-5">
                        {instructions.map((note, index) => (
                            <div key={index} className="flex items-start">
                                <div className="w-7 h-7 flex justify-center items-center bg-white rounded-full">
                                    <span className="text-orange-500 text-sm">{String(index + 1).padStart(2, '0')}</span>
                                </div>
                                <div className="text-gray-600 ml-2">{note}</div>
                            </div>
                        ))
                        }
                    </div>
                </div>
                <div className="flex space-x-4 mt-10">
                    <button
                        onClick={onAccepted}
                        className="px-8 py-3 bg-black text-white rounded-full hover:bg-gray-800 flex items-center" >
                        Start Interview
                        <img src={arrow} alt='external-link'
                            className=' w-3 h-3 ml-2'
                        />
                    </button>
                </div>
            </div>
        </div>
    )
}

const MockInterview = () => {
     const [step, setStep] = useState('consent');
    // const [isAccepted, setIsAccepted] = useState(false);
     const handleConsentAccepted = () => {
       setStep('instruction');
     }; 
     const handleInstructionAccepted = () => {
       setStep('interview');
     };
    return (
        <div>
      {step === 'consent' && <MockConsent onAccepted={handleConsentAccepted} />}
      {step === 'instruction' && <Instruction onAccepted={handleInstructionAccepted} />}
      {step === 'interview' && <Interview />}
     </div>
    )
}

export default MockInterview;